import { API_CONFIG } from "../../shared/api/config";
import composeRequest from "../../shared/api/core";
import { InvoicePDFUpload, StockOrderRequest, MatchInvoicePayload } from "../models";

const BASE_URL = API_CONFIG.API_BASE_PATH;

export const API_URLS = {
    masterSuppliersLinkedUrl: BASE_URL + 'korona/master/suppliers/business/link/',
    stockOrdersUrl: BASE_URL + 'korona/stockOrders/',
    stockOrderSummaryDataUrl: BASE_URL + 'korona/stockOrders/summary/',
    createStockOrderUrl: BASE_URL + 'korona/stockOrders/',
    getSOLinkedSupliersUrl: BASE_URL + 'korona/stock-orders/get_linked_suppliers/',
    uploadInvoicePDFUrl: BASE_URL + 'korona/stock-orders/invoice-pdf-parser/upload',
    parsePDFUrl: BASE_URL + 'korona/stock-orders/invoice-pdf-parser/upload',
    matchInvoiceProductsUrl: BASE_URL + 'korona/stock-orders/match-so-invoice-products',
    updateProductRetailerUrl: BASE_URL + 'korona/stock-orders/update-product-retailers-supplier-record',
    tempSOCustomerProductLinkUrl : BASE_URL + 'korona/stock-orders/temp-so-customer-prod-link',
    changeSRRocTempRecUrl : BASE_URL + 'korona/stock-orders/change-roc-temp-rec',
    productsNotLinkedDetailUrl: BASE_URL + 'korona/products/',
    catalogOrderTempProductsUrl: BASE_URL + 'korona/stock-orders/temp-products/',
    catalogOrderCorrectionsUrl: BASE_URL + 'korona/stock-orders/catalog-corrections/',
    catalogOrderCorrectionTasksUrl: BASE_URL + 'korona/stock-orders/catalog-correction-tasks/',
    supplierCatalogUrl: BASE_URL + 'korona/stock-orders/supplier-catalog/',
    catalogStockOrderTasksUrl: BASE_URL + 'korona/stock-orders/catalog-tasks/',
    koronaSuppliersByBusinessUrl: BASE_URL + 'korona/mobile-ksupp-list-by-buss/',
};

export const getStockOrdersByPage = (
    business_id: number | string,
    page: number, 
    pageSize: number, 
    searchTerm: string,
    orderBy: string | number,
) => {
    let URL = `${API_URLS.stockOrdersUrl}?business_id=${business_id}&page=${page}&page_size=${pageSize}`;
    if (searchTerm) {
        URL = `${API_URLS.stockOrdersUrl}?business_id=${business_id}&search=${searchTerm}&page=${page}&page_size=${pageSize}`;
    }
    if(orderBy){
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const getMatchedInvoiceItemList = (payload: any) => {
    const URL = API_URLS.matchInvoiceProductsUrl;
    return composeRequest(URL, 'POST', JSON.stringify(payload));
};

export const addStockOrder = (data: any) => {
    const URL = API_URLS.createStockOrderUrl;
    return composeRequest(URL, 'POST', JSON.stringify(data));
};

export const getStockOrderEditData = (
    stockOrderUuid: string,
    businessId: number | string,
) => {
    const URL = `${API_URLS.stockOrdersUrl}${stockOrderUuid}/edit-data/?business_id=${businessId}`;
    return composeRequest(URL, 'GET', null);
};

export const updateStockOrder = (
    stockOrderUuid: string,
    data: any,
    businessId: number | string,
) => {
    const URL = `${API_URLS.stockOrdersUrl}${stockOrderUuid}/?business_id=${businessId}`;
    return composeRequest(URL, 'PUT', JSON.stringify(data));
};

export const bookStockOrder = (
    stockOrderUuid: string,
    businessId: number | string,
) => {
    const URL = `${API_URLS.stockOrdersUrl}${stockOrderUuid}/book/?business_id=${businessId}`;
    return composeRequest(URL, 'POST', null);
};

export const finalizeStockOrder = (
    stockOrderUuid: string,
    businessId: number | string,
) => {
    const URL = `${API_URLS.stockOrdersUrl}${stockOrderUuid}/finalize/?business_id=${businessId}`;
    return composeRequest(URL, 'POST', null);
};

export const getStockOrdersSummary = (business_id: number | string) => {
    const URL = `${API_URLS.stockOrderSummaryDataUrl}?business_id=${business_id}`;
    return composeRequest(URL, 'GET', null);
};

export const searchMasterSuppliersLinked = (businessId: number | string, searchTerm: string) => {
    const URL = `${API_URLS.masterSuppliersLinkedUrl}?search=${searchTerm}&business__id=${businessId}`;
    return composeRequest(URL, 'GET', null);
};

export const uploadInvoicePDf = (payload:any) => {
    const URL = `${API_URLS.uploadInvoicePDFUrl}`;
    return composeRequest(URL, 'PUT', payload, "multipart/form-data");
};

export const getProductNotLinkedDetail = (product_uuid:any) => {
    const URL = `${API_URLS.productsNotLinkedDetailUrl}${product_uuid}/getProductsToLinkDetail/`;
    return composeRequest(URL, 'GET', "multipart/form-data");
};

export const parsePdf=(
    business_id: number,
    stored_aws_response_id :number,
    supplier_id:number,
    master_company_exists?: boolean,
    parser_setting_id?: number
)=>{
    let URL = `${API_URLS.parsePDFUrl}?business_id=${business_id}&stored_aws_response_id=${stored_aws_response_id}&supplier_id=${supplier_id}`;
    if (master_company_exists){
        URL = URL + `&master_company_exists=${master_company_exists}`
    }
    if (parser_setting_id){
        URL = URL + `&parser_setting_id=${parser_setting_id}`
    }

    console.log("URL",URL)
    return composeRequest(URL, 'GET', null)

};

export const postUpdateProducts = (payload:any) =>{
    const URL =`${API_URLS.updateProductRetailerUrl}`;
    return composeRequest(URL, 'POST', JSON.stringify(payload))

};

export const changeSORocTempRec =(data:any)=>{
    const URL = API_URLS.changeSRRocTempRecUrl;
    return composeRequest(URL, 'POST', JSON.stringify(data));
}
  

export const getSOLinkedSuppliers=(
    business_id: number
)=>{
    let URL = `${API_URLS.getSOLinkedSupliersUrl}?business_id=${business_id}`
    return composeRequest(URL, 'GET', null)
};

/** Korona suppliers for a business (same source as mobile stock-order supplier picker). */
export const getKoronaSuppliersByBusiness = (
    business_id: number | string,
    searchTerm?: string,
    pageSize: number = 2000,
) => {
    let URL = `${API_URLS.koronaSuppliersByBusinessUrl}?business_id=${business_id}&page_size=${pageSize}`;
    const search = searchTerm ? searchTerm.trim() : '';
    if (search) {
        URL = `${URL}&search=${encodeURIComponent(search)}`;
    }
    return composeRequest(URL, 'GET', null);
};

// Universal Catalog Ordering (FR-04/FR-05): Data Team review queue for
// temporary products auto-created from catalog-ordered stock orders.
export const getCatalogOrderTempProducts = (
    business_id: number | string,
    page: number,
    pageSize: number,
    tempProductStatus?: string,
    stockOrderId?: string,
) => {
    let URL = `${API_URLS.catalogOrderTempProductsUrl}?business_id=${business_id}&page=${page}&page_size=${pageSize}`;
    if (tempProductStatus) {
        URL += `&status=${tempProductStatus}`;
    }
    if (stockOrderId) {
        URL += `&stock_order_id=${stockOrderId}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const decideCatalogOrderTempProduct = (
    tempProductId: number,
    status: 'APPROVED' | 'DUPLICATE',
    replacementProductUuid?: string,
) => {
    const URL = `${API_URLS.catalogOrderTempProductsUrl}${tempProductId}/decision/`;
    return composeRequest(URL, 'POST', JSON.stringify({
        status,
        replacement_product_uuid: replacementProductUuid,
    }));
};

export const undoCatalogOrderTempProductDecision = (tempProductId: number) => {
    const URL = `${API_URLS.catalogOrderTempProductsUrl}${tempProductId}/undo/`;
    return composeRequest(URL, 'POST', null);
};

export const getCatalogOrderCorrections = (
    businessId: number | string,
    page: number,
    pageSize: number,
    status?: string,
) => {
    let URL = `${API_URLS.catalogOrderCorrectionsUrl}?business_id=${businessId}&page=${page}&page_size=${pageSize}`;
    if (status) {
        URL += `&status=${status}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const fixCatalogOrderCorrectionTask = (taskId: number) => {
    const URL = `${API_URLS.catalogOrderCorrectionTasksUrl}${taskId}/fix/`;
    return composeRequest(URL, 'POST', null);
};

export const fixCatalogOrderCorrection = (correctionId: number) => {
    const URL = `${API_URLS.catalogOrderCorrectionsUrl}${correctionId}/fix/`;
    return composeRequest(URL, 'POST', null);
};

// Universal Catalog Ordering (FR-01): browse the master catalog (MCPI) mapped
// to a Korona supplier, for building a stock order from items that may not
// exist locally yet. `ordering` is required (name | reorder_code | case_qty,
// optional `-` prefix for descending). `locationId` and `organizationalUnitId`
// are required for location-scoped enrichment. Optional `stockStatus`:
// all | existing | new.
export const getSupplierCatalog = (
    business_id: number | string,
    supplier_id: string,
    ordering: string,
    locationId: number | string,
    organizationalUnitId: string,
    searchTerm?: string,
    page?: number,
    pageSize?: number,
    stockStatus?: string,
) => {
    let URL = `${API_URLS.supplierCatalogUrl}?business_id=${business_id}&supplier_id=${supplier_id}`
        + `&location_id=${locationId}&organizational_unit_id=${encodeURIComponent(organizationalUnitId)}`
        + `&page=${page || 1}&page_size=${pageSize || 20}&ordering=${encodeURIComponent(ordering)}`;
    if (searchTerm) {
        URL += `&search=${encodeURIComponent(searchTerm)}`;
    }
    if (stockStatus && stockStatus !== 'all') {
        URL += `&stock_status=${encodeURIComponent(stockStatus)}`;
    }
    return composeRequest(URL, 'GET', null);
};

// Universal Catalog Ordering (FR-02): task history for the async processing
// triggered when a stock order contains catalog (MCPI) items.
export const getCatalogStockOrderTasks = (
    business_id: number | string,
    page?: number,
    pageSize?: number,
    orderBy?: string,
    status?: string,
    search?: string,
) => {
    let URL = `${API_URLS.catalogStockOrderTasksUrl}?business_id=${business_id}&`;
    if (page !== undefined) URL += `page=${page}&`;
    if (pageSize !== undefined) URL += `page_size=${pageSize}&`;
    if (orderBy) URL += `ordering=${encodeURIComponent(orderBy)}&`;
    if (status) URL += `status=${encodeURIComponent(status)}&`;
    if (search) URL += `search=${encodeURIComponent(search)}&`;
    return composeRequest(URL, 'GET', null);
};

export const getCatalogStockOrderTaskItems = (
    taskId: number | string,
    page?: number,
    pageSize?: number,
    orderBy?: string,
    status?: string,
) => {
    let URL = `${API_URLS.catalogStockOrderTasksUrl}${taskId}/items/?`;
    if (page !== undefined) URL += `page=${page}&`;
    if (pageSize !== undefined) URL += `page_size=${pageSize}&`;
    if (orderBy) URL += `ordering=${encodeURIComponent(orderBy)}&`;
    if (status) URL += `status=${encodeURIComponent(status)}&`;
    return composeRequest(URL, 'GET', null);
};
